import type { CSSProperties } from "react";
import Icon from "../Icon/Icon";
import { cn } from "@/shared/utils/cn";

const Rotate = ({
  degrees,
  size,
  fill = "dark",
  className,
  style,
  ...rest
}: {
  degrees?: string;
  size?: string;
  fill?: string;
  className?: string;
  style?: CSSProperties;
  [key: string]: any;
}) => {
  const sizeCls =
    size === "2rem" ? "h-8 w-8" : size ? `h-[${size}] w-[${size}]` : "";

  let fillCls = "";
  const fillStyle: CSSProperties = {};
  if (fill) {
    if (fill.startsWith("#")) {
      fillStyle.fill = fill;
    } else if (fill.startsWith("var(--")) {
      const varMap: Record<string, string> = {
        "var(--text)": "fill-text",
        "var(--white)": "fill-white",
        "var(--primary)": "fill-primary",
      };
      fillCls = varMap[fill] ?? "";
      if (!fillCls) fillStyle.fill = fill;
    } else {
      fillCls = `fill-${String(fill).replace(/_/g, "-")}`;
    }
  } else {
    fillCls = "fill-dark";
  }

  return (
    <Icon
      className={cn(sizeCls, fillCls, className)}
      style={{
        transform: `rotate(${degrees})`,
        transition: "all 0.2s ease",
        ...fillStyle,
        ...style,
      }}
      {...rest}
    />
  );
};

export default Rotate;
